var map = {
	"./avatar-asis.png": 524,
	"./avatar-bot-dialogue.png": 228,
	"./avatar-dave.png": 525,
	"./avatar-ken.png": 526,
	"./avatar-maja.png": 527,
	"./avatar-ryan.png": 528,
	"./avatar-terence.png": 529
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 523;


//////////////////
// WEBPACK FOOTER
// ./src/imgs ^\.\/avatar\-.*\.png$
// module id = 523
// module chunks = 0